// extracted by mini-css-extract-plugin
export default {"th":"WalletEtfsList_th__lEta1","td":"WalletEtfsList_td__S85wp","emphasis":"WalletEtfsList_emphasis__2KfKZ"};